/* eslint-disable */

import React from "react";

function Header() {
  return (
    <header className="container user-avatar">
      <h1>calculate hypotenuse of a triangle</h1>
    </header>
  );
}
export default Header;
